import React from 'react'
import { Link } from 'react-router-dom'

const Sidebar = () => {
  return (
    <div className="modal fixed-right fade" id="modalSidebar" tabIndex="-1" role="dialog" style={{display:"none"}} aria-hidden="true">
      <div className="modal-dialog modal-dialog-vertical" role="document">
        <div className="modal-content">

          <button type="button" className="close" data-dismiss="modal" aria-label="Close">
            <i className="bi bi-x" style={{fontSize:"2.5rem"}} aria-hidden="true"></i>
          </button>

          <div className="modal-body px-10 my-auto">

            <ul className="nav nav-vertical nav-unstyled font-size-h2" id="sidebarNav">

              <li className="nav-item">
                <a href={'/'} className="nav-link w-100 d-flex justify-content-between">Home <i className='bi bi-arrow-right'></i></a>
              </li>
              <li className="nav-item">
                <a href={'/collections/framed-art'} className="nav-link w-100 d-flex justify-content-between">Framed Art <i className='bi bi-arrow-right'></i></a>
              </li>
              <li className="nav-item">
                <a href={'https://wa.me/917676811454'} className="nav-link w-100 d-flex justify-content-between">Chat Now <i className='bi bi-arrow-right'></i></a>
              </li>
              <li className="nav-item">
                <a href={'/cart'} className="nav-link w-100 d-flex justify-content-between">Cart <i className='bi bi-arrow-right'></i></a>
              </li>
              <li className="nav-item">
                <a href="/user/myorders" className="nav-link w-100 d-flex justify-content-between">My Account <i className='bi bi-arrow-right'></i></a>
              </li>
              <li className="nav-item">
                <a href={'/login'} className="nav-link w-100 d-flex justify-content-between">Login <i className='bi bi-arrow-right'></i></a>
              </li>
              
            </ul>

          </div>

          <div className="moda-body px-10 py-9">

            <ul className="list-inline">
              <li className="list-inline-item">
                <a className="text-gray-350" href="#!">
                  <i className="bi bi-facebook"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-gray-350" href="#!">
                  <i className="bi bi-youtube"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-gray-350" href="#!">
                  <i className="bi bi-twitter"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-gray-350" href="#!">
                  <i className="bi bi-instagram"></i>
                </a>
              </li>
              <li className="list-inline-item">
                <a className="text-gray-350" href="#!">
                  <i className="bi bi-medium"></i>
                </a>
              </li>
            </ul>

            <div className="font-size-xxs text-gray-350">
              © 2022 All rights reserved. Getart.
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default Sidebar